import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {Link} from 'react-router-dom';
import {Container, Card, Grid, Button, Dimmer, Loader} from 'semantic-ui-react';
import KatashikiesListTable from './katashikiesListTable';
import {getColumns} from './katashikiesListColumns';

const {
  navigateTo,
  fetchVehiclesModelsList,
} = Actions;

const Index = () => {
  const permissions = useSelector((state) => state.session.permissions);
  const loading = useSelector((state) => state.vehiclesModelsList.loading);
  const katashikiesList = useSelector((state) => state.vehiclesModelsList.list);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.CombosManagement, scopes.See) &&
      !hasAccessPermission(permissions, resources.CombosManagement, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    dispatch(fetchVehiclesModelsList(true));
  }, []);

  const columns = getColumns();
  
  const renderCombosListTable = () => {
    return loading ?
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer> :
      <KatashikiesListTable tableColumns={columns}
        tableData={katashikiesList} />;
  };

  return (
    <Container fluid>
      <Card raised fluid>
        <div className='title-bar'>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <div className='title'>
                  <h2>Administración de Combos por Katashikis</h2>
                </div>
              </Grid.Column>
              <Grid.Column textAlign='right'>
                <Link to={paths.CombosList}>
                  <Button primary>VISTA POR COMBOS</Button>
                </Link>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Card raised fluid>
        <Grid padded>
          <Grid.Row>
            <Grid.Column>
              {renderCombosListTable()}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    </Container>
  );
};

export default Index;
